module.exports = __webpack_public_path__ + "static/media/deleteIcon.a274fdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/deleteIcon.svg
// module id = 857
// module chunks = 0